// extracted by mini-css-extract-plugin
module.exports = {"passengers":"passengers-3A-Um","passenger":"passenger-2XKa4"};